import { FBPageTableContainer } from 'components/FbUI/Page/styles'
import { SenderEmailSettings } from 'features/settings/components/SenderEmailSettings'

export function EmailOutreachSettingsPage() {
  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageTableContainer>
        <SenderEmailSettings />
      </FBPageTableContainer>
    </div>
  )
}
